/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenanceLevelResponseDto } from './PartnerMaintenanceLevelResponseDto';
import {
    PartnerMaintenanceLevelResponseDtoFromJSON,
    PartnerMaintenanceLevelResponseDtoFromJSONTyped,
    PartnerMaintenanceLevelResponseDtoToJSON,
    PartnerMaintenanceLevelResponseDtoToJSONTyped,
} from './PartnerMaintenanceLevelResponseDto';
import type { PartnerMaintenanceScopeResponseDto } from './PartnerMaintenanceScopeResponseDto';
import {
    PartnerMaintenanceScopeResponseDtoFromJSON,
    PartnerMaintenanceScopeResponseDtoFromJSONTyped,
    PartnerMaintenanceScopeResponseDtoToJSON,
    PartnerMaintenanceScopeResponseDtoToJSONTyped,
} from './PartnerMaintenanceScopeResponseDto';

/**
 * 
 * @export
 * @interface PartnerMaintenanceRulesResponseDto
 */
export interface PartnerMaintenanceRulesResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    status: PartnerMaintenanceRulesResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    rulesStatus: PartnerMaintenanceRulesResponseDtoRulesStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    businessHoursStart?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    businessHoursEnd?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    workingDays: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    holidayCalendarCode: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    exclusionsText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    resolutionStopSignal: PartnerMaintenanceRulesResponseDtoResolutionStopSignalEnum;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    recurrenceWindowDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    restoredAvailableMinutes?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    interventionMode?: PartnerMaintenanceRulesResponseDtoInterventionModeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    priceCurrency: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    excludeHolidays: boolean;
    /**
     * 
     * @type {Array<PartnerMaintenanceLevelResponseDto>}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    levels: Array<PartnerMaintenanceLevelResponseDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeResponseDto>}
     * @memberof PartnerMaintenanceRulesResponseDto
     */
    scopeRules: Array<PartnerMaintenanceScopeResponseDto>;
}


/**
 * @export
 */
export const PartnerMaintenanceRulesResponseDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type PartnerMaintenanceRulesResponseDtoStatusEnum = typeof PartnerMaintenanceRulesResponseDtoStatusEnum[keyof typeof PartnerMaintenanceRulesResponseDtoStatusEnum];

/**
 * @export
 */
export const PartnerMaintenanceRulesResponseDtoRulesStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED'
} as const;
export type PartnerMaintenanceRulesResponseDtoRulesStatusEnum = typeof PartnerMaintenanceRulesResponseDtoRulesStatusEnum[keyof typeof PartnerMaintenanceRulesResponseDtoRulesStatusEnum];

/**
 * @export
 */
export const PartnerMaintenanceRulesResponseDtoResolutionStopSignalEnum = {
    DeclaredClosedAt: 'DECLARED_CLOSED_AT'
} as const;
export type PartnerMaintenanceRulesResponseDtoResolutionStopSignalEnum = typeof PartnerMaintenanceRulesResponseDtoResolutionStopSignalEnum[keyof typeof PartnerMaintenanceRulesResponseDtoResolutionStopSignalEnum];

/**
 * @export
 */
export const PartnerMaintenanceRulesResponseDtoInterventionModeEnum = {
    Onsite: 'ONSITE',
    Remote: 'REMOTE',
    Both: 'BOTH'
} as const;
export type PartnerMaintenanceRulesResponseDtoInterventionModeEnum = typeof PartnerMaintenanceRulesResponseDtoInterventionModeEnum[keyof typeof PartnerMaintenanceRulesResponseDtoInterventionModeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceRulesResponseDto interface.
 */
export function instanceOfPartnerMaintenanceRulesResponseDto(value: object): value is PartnerMaintenanceRulesResponseDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('rulesStatus' in value) || value['rulesStatus'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('workingDays' in value) || value['workingDays'] === undefined) return false;
    if (!('holidayCalendarCode' in value) || value['holidayCalendarCode'] === undefined) return false;
    if (!('resolutionStopSignal' in value) || value['resolutionStopSignal'] === undefined) return false;
    if (!('priceCurrency' in value) || value['priceCurrency'] === undefined) return false;
    if (!('excludeHolidays' in value) || value['excludeHolidays'] === undefined) return false;
    if (!('levels' in value) || value['levels'] === undefined) return false;
    if (!('scopeRules' in value) || value['scopeRules'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceRulesResponseDtoFromJSON(json: any): PartnerMaintenanceRulesResponseDto {
    return PartnerMaintenanceRulesResponseDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceRulesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceRulesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'status': json['status'],
        'rulesStatus': json['rulesStatus'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'timezone': json['timezone'],
        'businessHoursStart': json['businessHoursStart'] == null ? undefined : json['businessHoursStart'],
        'businessHoursEnd': json['businessHoursEnd'] == null ? undefined : json['businessHoursEnd'],
        'workingDays': json['workingDays'],
        'holidayCalendarCode': json['holidayCalendarCode'],
        'exclusionsText': json['exclusionsText'] == null ? undefined : json['exclusionsText'],
        'resolutionStopSignal': json['resolutionStopSignal'],
        'recurrenceWindowDays': json['recurrenceWindowDays'] == null ? undefined : json['recurrenceWindowDays'],
        'restoredAvailableMinutes': json['restoredAvailableMinutes'] == null ? undefined : json['restoredAvailableMinutes'],
        'interventionMode': json['interventionMode'] == null ? undefined : json['interventionMode'],
        'priceCurrency': json['priceCurrency'],
        'excludeHolidays': json['excludeHolidays'],
        'levels': ((json['levels'] as Array<any>).map(PartnerMaintenanceLevelResponseDtoFromJSON)),
        'scopeRules': ((json['scopeRules'] as Array<any>).map(PartnerMaintenanceScopeResponseDtoFromJSON)),
    };
}

export function PartnerMaintenanceRulesResponseDtoToJSON(json: any): PartnerMaintenanceRulesResponseDto {
    return PartnerMaintenanceRulesResponseDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceRulesResponseDtoToJSONTyped(value?: PartnerMaintenanceRulesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'status': value['status'],
        'rulesStatus': value['rulesStatus'],
        'validFrom': value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'timezone': value['timezone'],
        'businessHoursStart': value['businessHoursStart'],
        'businessHoursEnd': value['businessHoursEnd'],
        'workingDays': value['workingDays'],
        'holidayCalendarCode': value['holidayCalendarCode'],
        'exclusionsText': value['exclusionsText'],
        'resolutionStopSignal': value['resolutionStopSignal'],
        'recurrenceWindowDays': value['recurrenceWindowDays'],
        'restoredAvailableMinutes': value['restoredAvailableMinutes'],
        'interventionMode': value['interventionMode'],
        'priceCurrency': value['priceCurrency'],
        'excludeHolidays': value['excludeHolidays'],
        'levels': ((value['levels'] as Array<any>).map(PartnerMaintenanceLevelResponseDtoToJSON)),
        'scopeRules': ((value['scopeRules'] as Array<any>).map(PartnerMaintenanceScopeResponseDtoToJSON)),
    };
}

